import React from 'react';
import { TruckIcon, ShieldCheckIcon, HeadphonesIcon, CreditCardIcon } from 'lucide-react';
export function FeaturesSection() {
  return <section className="max-w-7xl mx-auto px-4" data-id="element-173">
      <div data-id="element-174">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6" data-id="element-175">
          <div className="flex items-center gap-4" data-id="element-176">
            <div className="w-12 h-12 bg-primary-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-177">
              <TruckIcon className="w-6 h-6 text-primary-600" data-id="element-178" />
            </div>
            <div data-id="element-179">
              <h3 className="font-semibold text-gray-900 text-sm" data-id="element-180">
                Free Shipping
              </h3>
              <p className="text-xs text-gray-500" data-id="element-181">On orders over PKR 5,000</p>
            </div>
          </div>

          <div className="flex items-center gap-4" data-id="element-182">
            <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-183">
              <ShieldCheckIcon className="w-6 h-6 text-green-600" data-id="element-184" />
            </div>
            <div data-id="element-185">
              <h3 className="font-semibold text-gray-900 text-sm" data-id="element-186">
                Genuine Products
              </h3>
              <p className="text-xs text-gray-500" data-id="element-187">100% authentic items</p>
            </div>
          </div>

          <div className="flex items-center gap-4" data-id="element-188">
            <div className="w-12 h-12 bg-primary-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-189">
              <HeadphonesIcon className="w-6 h-6 text-primary-600" data-id="element-190" />
            </div>
            <div data-id="element-191">
              <h3 className="font-semibold text-gray-900 text-sm" data-id="element-192">
                24/7 Support
              </h3>
              <p className="text-xs text-gray-500" data-id="element-193">Dedicated assistance</p>
            </div>
          </div>

          <div className="flex items-center gap-4" data-id="element-194">
            <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-195">
              <CreditCardIcon className="w-6 h-6 text-purple-600" data-id="element-196" />
            </div>
            <div data-id="element-197">
              <h3 className="font-semibold text-gray-900 text-sm" data-id="element-198">
                Secure Payment
              </h3>
              <p className="text-xs text-gray-500" data-id="element-199">Multiple options</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}